<template>
    <div>
        <div class="u-d-flex flex-state-buttons p-executive-dashboard__reserves">
            <h2 class="u-margin-top-10 u-r-no-margin">
                Reserves 
                <span v-if="diseaseOrAccident || claimType === 'personal_injury'">
                    {{ diseaseOrAccident === 'disease' ? 'by Disease' : 'by Accident' }}
                </span>
                <span v-else>
                    by Claim Type
                </span>
            </h2>
            <option-filters>
                <li :class="{'m-option-filters--active' : chartType === 'average'}"
                    @click="changeType('average')">
                    Average
                </li>
                <li :class="{'m-option-filters--active' : chartType === 'total'}"
                    @click="changeType('total')">
                    Total
                </li>
                <li :class="{'m-option-filters--active' : chartType === 'trend-average'}"
                    @click="changeType('trend-average')">
                    Trends: Average Reserve
                </li>
                <li :class="{'m-option-filters--active' : chartType === 'trend-total'}"
                    @click="changeType('trend-total')">
                    Trends: Total Reserve
                </li>
            </option-filters>
        </div>
        <summary-charts v-if="(chartType === 'average'|| chartType ==='total') && show"
                        type="value"
                        :run-type="chartType === 'average' ? 'averageReserve' : 'totalReserve'"
                        :chart-data="chartType === 'average' ? averageReservesChartData : totalReservesChartData">
        </summary-charts>
        <trends-chart v-if="chartType === 'trend-average' && show"
                      type="value"
                      showing="average"
                      :chart-data="trendsInAverageReservesChartData">
        </trends-chart>
        <trends-chart v-if="chartType === 'trend-total' && show"
                      type="value"
                      showing="total"
                      :chart-data="trendsInTotalReservesChartData">
        </trends-chart>
    </div>
</template>

<script>
    import OptionFilters from 'components/OptionFilters';
    import SummaryCharts from "./charts/SummaryCharts";
    import {mapGetters} from 'vuex';
    import TrendsChart from "./charts/TrendsChart";

    export default {
        name: "reserve-section",
        components: {
            TrendsChart,
            SummaryCharts,
            OptionFilters
        },
        data: () => ({chartType: 'average', show: true}),
        computed: mapGetters('dashboards', [
            'averageReservesChartData',
            'totalReservesChartData',
            'trendsInReservesChartData',
            'trendsInAverageReservesChartData',
            'trendsInTotalReservesChartData',
            'diseaseOrAccident',
            'claimType',
        ]),
        methods: {
            changeType(type) {
                this.chartType = type;
                this.show = false;
                setTimeout(() => this.show = true, 1);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ReserveSection.vue?5e95a847